import React, { memo } from 'react';

interface Props {
  size: number;
}

const JumpCloud = ({ size = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20.7,15.854c-.081,0-.142.02-.223.02H11.118a5.494,5.494,0,0,1,3.065-2.618,2.951,2.951,0,0,1-1.218-2.9,2.991,2.991,0,1,1,4.685,2.9,5.348,5.348,0,0,1,3.046,2.6c-.081,0-.548-1.035,0,0Zm-10.291,0a2.081,2.081,0,0,1,.528-1.055,4.852,4.852,0,0,0-1.766-1.117,2.477,2.477,0,0,0-.548-4.3,2.522,2.522,0,0,0-3,.994,2.468,2.468,0,0,0,.67,3.309,4.534,4.534,0,0,0-2.538,2.171h6.654Z" />
    <path d="M22.079,12.017a2.261,2.261,0,0,1-.71,3.654,4.086,4.086,0,0,0-1.077-1.543,5.765,5.765,0,0,0-1.441-1.1,3.944,3.944,0,0,0,.67-1.441,2.223,2.223,0,0,1,2.557.426h0ZM2.065,15.2a2.618,2.618,0,0,0,1.014.568,2.716,2.716,0,0,1,.833-1.3,5.236,5.236,0,0,1,1.218-.994,3.15,3.15,0,0,1-.488-2.436,2.537,2.537,0,0,0-2.984.994A2.456,2.456,0,0,0,2.064,15.2c.163.162-.02-.02,0,0Zm8.85-3.532a3.112,3.112,0,0,1-.568,1.786,5.681,5.681,0,0,1,1.035.792,6.163,6.163,0,0,1,1.563-1.239,3.679,3.679,0,0,1,1.624-5.622,3.361,3.361,0,0,0-3.532-1.136A3.315,3.315,0,0,0,8.723,8.668a3.194,3.194,0,0,1,2.192,3Z" />
    <path d="M23.987,13.3a3.544,3.544,0,0,0-3.512-3.187,2.5,2.5,0,0,0-.386.02,4.282,4.282,0,0,0-4.547-3.512A4.631,4.631,0,0,0,11,4.994,4.565,4.565,0,0,0,7.626,7.977,3.771,3.771,0,0,0,4.58,9.723a3.744,3.744,0,1,0-.831,7.393H20.678a.941.941,0,0,0,.345-.061A3.54,3.54,0,0,0,23.986,13.3Zm-3.066,3.227c1.422-.223-.081.021,0,0a.692.692,0,0,1-.2.041H3.749a3.2,3.2,0,1,1,1.1-6.191A3.229,3.229,0,0,1,8.031,8.546,4.044,4.044,0,0,1,15.3,7.207,3.717,3.717,0,0,1,19.6,10.8a2.949,2.949,0,1,1,1.319,5.725Z" />
  </svg>
);

export default memo(JumpCloud);
